var React = require('react');

function ArrowNormal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22 6L12 0.226496L12 11.7735L22 6ZM-8.74228e-08 7L13 7L13 5L8.74228e-08 5L-8.74228e-08 7Z"}));
}

ArrowNormal.defaultProps = {"viewBox":"0 0 22 12","fill":"none"};

module.exports = ArrowNormal;

ArrowNormal.default = ArrowNormal;
